module.exports = __webpack_public_path__ + "media/assets/images/tour/5a_Tour_4-b378e2260041cf828016ecb367f403e3.png";